import "./vote.scss";
import Toast from "../toast";
import {xhr} from "../../../client/helper";


Array.from(document.querySelectorAll('.js-vote-button')).forEach(button => {
    button.addEventListener('click', event => {
        const data = new FormData();
        const direction = 0 + button.classList.contains('_up');
        const parent = button.parentElement;
        const counter = button.parentElement.querySelector('.js-vote-counter');

        data.append('direction', direction);
        data.append('article', button.getAttribute('data-id'));

        xhr('POST', '/article-change-vote/', data).then(response => {
            if (response.error) {
                Toast.error(response.error.message);
            } else {
                Toast.success("Спасибо за оценку");

                if (parent) {
                    parent.className = 'vote ' + (direction ? '_up' : '_down');
                }

                if (counter) {
                    counter.innerHTML = response.count;
                }
            }
        });
    });
});
